/** 幸運飛艇 / 極速飛艇 / 極速賽車 / 澳洲幸運10（10 球開獎，與 PK10 類玩法一致） */

export const LOTTERY_NAMES_PK10 = ['幸運飛艇', '幸运飞艇', '極速飛艇', '极速飞艇', '極速賽車', '极速赛车', '澳洲幸運10', '澳洲幸运10']

export function isPk10Lottery(name) {
  return LOTTERY_NAMES_PK10.includes(name)
}

export const playTypesPk10 = [
  '兩面',
  '單球1-10',
  '冠亞和',
  '三、四、五、六名',
  '七、八、九、十名'
]

const PK10_RANK_TITLES = [
  '冠軍',
  '亞軍',
  '第三名',
  '第四名',
  '第五名',
  '第六名',
  '第七名',
  '第八名',
  '第九名',
  '第十名'
]

const ODDS_SIDE = ''

/** 兩面：冠軍～第五名單雙+大小+龍虎；第六～十名單雙+大小；冠亞軍和 */
export function buildWagerSectionsPk10LiangMian() {
  const sections = []
  for (let i = 0; i < 10; i++) {
    const rank = i + 1
    const snDan = 610 + rank
    const snDa = 620 + rank
    const options = [
      { name: '單', sn: snDan, sub: 1, odds: ODDS_SIDE },
      { name: '雙', sn: snDan, sub: 2, odds: ODDS_SIDE },
      { name: '大', sn: snDa, sub: 1, odds: ODDS_SIDE },
      { name: '小', sn: snDa, sub: 2, odds: ODDS_SIDE }
    ]
    if (rank <= 5) {
      const snLh = 630 + rank
      options.push(
        { name: '龍', sn: snLh, sub: 1, odds: ODDS_SIDE },
        { name: '虎', sn: snLh, sub: 2, odds: ODDS_SIDE }
      )
    }
    sections.push({
      title: PK10_RANK_TITLES[i],
      options
    })
  }
  sections.push({
    title: '冠、亞軍和',
    options: [
      { name: '冠亞大', sn: 637, sub: 1, odds: '' },
      { name: '冠亞小', sn: 637, sub: 2, odds: '' },
      { name: '冠亞單', sn: 636, sub: 1, odds: '' },
      { name: '冠亞雙', sn: 636, sub: 2, odds: '' }
    ]
  })
  return sections
}

export const wagerSectionsPk10LiangMian = buildWagerSectionsPk10LiangMian()

const ODDS_PK10_NUM = ''

/** 單球1-10：冠軍～第十名各 01～10，sn_601_1～sn_610_10 */
export function buildWagerSectionsPk10DanQiu110() {
  return PK10_RANK_TITLES.map((title, rankIdx) => {
    const sn = 601 + rankIdx
    const cells = []
    for (let num = 1; num <= 10; num++) {
      cells.push({
        sn,
        sub: num,
        pkCls: 'pk_' + String(num).padStart(2, '0'),
        text: String(num).padStart(2, '0'),
        odds: ODDS_PK10_NUM
      })
    }
    return { title, cells }
  })
}

export const wagerSectionsPk10DanQiu110 = buildWagerSectionsPk10DanQiu110()

/** 冠亞軍和點位 3～19 對應 sn_638_* 賠率（與原站一致） */
const GUAN_HE_SUM_ODDS = {
  3: '',
  4: '',
  5: '',
  6: '',
  7: '',
  8: '',
  9: '',
  10: '',
  11: '',
  12: '',
  13: '',
  14: '',
  15: '',
  16: '',
  17: '',
  18: '',
  19: ''
}

function buildPk10GuanYaHeSumOptions() {
  const opts = []
  for (let s = 3; s <= 19; s++) {
    opts.push({
      kind: 'text',
      name: String(s),
      sn: 638,
      sub: s,
      odds: GUAN_HE_SUM_ODDS[s]
    })
  }
  return opts
}

/** 冠軍/亞軍：01～10 + 單雙大小龍虎（前兩名含龍虎） */
function buildPk10GuanYaRankComboOptions(rankIdx) {
  const sn = 601 + rankIdx
  const opts = []
  for (let n = 1; n <= 10; n++) {
    opts.push({
      kind: 'roller',
      sn,
      sub: n,
      pkCls: 'pk_' + String(n).padStart(2, '0'),
      text: String(n).padStart(2, '0'),
      odds: ODDS_PK10_NUM
    })
  }
  const rankNum = rankIdx + 1
  const sDan = 610 + rankNum
  const sDa = 620 + rankNum
  opts.push(
    { kind: 'text', name: '單', sn: sDan, sub: 1, odds: ODDS_SIDE },
    { kind: 'text', name: '雙', sn: sDan, sub: 2, odds: ODDS_SIDE },
    { kind: 'text', name: '大', sn: sDa, sub: 1, odds: ODDS_SIDE },
    { kind: 'text', name: '小', sn: sDa, sub: 2, odds: ODDS_SIDE }
  )
  if (rankNum <= 5) {
    const sLh = 630 + rankNum
    opts.push(
      { kind: 'text', name: '龍', sn: sLh, sub: 1, odds: ODDS_SIDE },
      { kind: 'text', name: '虎', sn: sLh, sub: 2, odds: ODDS_SIDE }
    )
  }
  return opts
}

/** 冠亞和 */
export const wagerSectionsPk10GuanYaZuHe = [
  {
    title: '冠亞和',
    options: buildPk10GuanYaHeSumOptions()
  },
  {
    title: '大小',
    options: [
      { kind: 'text', name: '冠亞大', sn: 637, sub: 1, odds: '' },
      { kind: 'text', name: '冠亞小', sn: 637, sub: 2, odds: '' }
    ]
  },
  {
    title: '單雙',
    options: [
      { kind: 'text', name: '冠亞單', sn: 636, sub: 1, odds: '' },
      { kind: 'text', name: '冠亞雙', sn: 636, sub: 2, odds: '' }
    ]
  },
  { title: '冠軍', options: buildPk10GuanYaRankComboOptions(0) },
  { title: '亞軍', options: buildPk10GuanYaRankComboOptions(1) }
]

function buildPk10RankRangeSections(startRankIdx, endRankIdxInclusive) {
  const out = []
  for (let i = startRankIdx; i <= endRankIdxInclusive; i++) {
    out.push({
      title: PK10_RANK_TITLES[i],
      options: buildPk10GuanYaRankComboOptions(i)
    })
  }
  return out
}

/** 三、四、五、六名：第三名 sn_603～第六名 sn_606；三至五名含龍虎，第六名僅單雙大小 */
export const wagerSectionsPk10SanSiWuLiu = buildPk10RankRangeSections(2, 5)

/** 七、八、九、十名：第七名 sn_607～第十名 sn_610；均無龍虎 */
export const wagerSectionsPk10QiBaJiuShi = buildPk10RankRangeSections(6, 9)

const PK10_NAMES = ['冠軍','亞軍','第三名','第四名','第五名','第六名','第七名','第八名','第九名','第十名']
const PK10_VARIANTS = ['單','雙','大','小']

function makePk10Items(posIndices) {
  const items = []
  for (const pi of posIndices) {
    for (const v of PK10_VARIANTS) items.push({ text: ` ${PK10_NAMES[pi]} - ${v}:`, count: '0期' })
  }
  for (const v of PK10_VARIANTS) items.push({ text: ` 冠亞軍和 - ${v}:`, count: '0期' })
  const pairs = [[0,9],[1,8],[2,7],[3,6],[4,5]]
  for (let pi = 0; pi < 5; pi++) {
    if (!posIndices.includes(pairs[pi][0]) && !posIndices.includes(pairs[pi][1])) continue
    items.push({ text: ` ${PK10_NAMES[pairs[pi][0]]} - 龍`, count: '0期' })
    items.push({ text: ` ${PK10_NAMES[pairs[pi][0]]} - 虎`, count: '0期' })
    items.push({ text: ` ${PK10_NAMES[pairs[pi][1]]} - 龍`, count: '0期' })
    items.push({ text: ` ${PK10_NAMES[pairs[pi][1]]} - 虎`, count: '0期' })
  }
  return items
}

export const longDragonItemsPk10LiangMian = makePk10Items([0,1,2,3,4,5,6,7,8,9])

/** 三、四、五、六名頁兩面長龍 */
export const longDragonItemsPk10SanSiWuLiu = makePk10Items([2,3,4,5])

/** 七、八、九、十名頁兩面長龍 */
export const longDragonItemsPk10QiBaJiuShi = makePk10Items([6,7,8,9])

export const ballNavLabelsPk10LiangMian = ['冠亞軍和', '冠亞軍和大小', '冠亞軍和單雙']

export const rankPanelsPk10LiangMian = [
  [['16'], ['15'], ['6'], ['5'], ['9'], ['19'], ['12'], ['10'], ['13'], ['7']],
  [
    ['小'],
    ['大', '大'],
    ['小', '小', '小', '小', '小', '小'],
    ['大', '大', '大'],
    ['小', '小', '小', '小'],
    ['大', '大', '大'],
    ['小', '小'],
    ['小'],
    ['小'],
    ['小']
  ],
  [
    ['單'],
    ['單'],
    ['單', '單', '單'],
    ['雙', '雙', '雙', '雙', '雙', '雙', '雙', '雙'],
    ['單'],
    ['雙'],
    ['單'],
    ['單', '單', '單'],
    ['單', '單'],
    ['雙', '雙']
  ]
]